"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Storybook = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = require("react-jss");
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _Scroller = _interopRequireWildcard(require("./Scroller.styles"));
var _Theme = require("../../themes/Theme");
var _defaultProps = _interopRequireDefault(require("../../utils/defaultProps"));
var _splitCommonFromProps7 = _interopRequireDefault(require("../../utils/splitCommonFromProps"));
var _excluded = ["alignItems", "background", "children", "className", "direction", "shadowColor", "gap"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /* eslint-disable @atg/css-rtl-support */ /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var SCROLL_STEP = 200;
var THRESHOLD = 10;
var Scroller = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _splitCommonFromProps = (0, _splitCommonFromProps7.default)(props, _Scroller.scrollerCommon),
    _splitCommonFromProps2 = _slicedToArray(_splitCommonFromProps, 2),
    common = _splitCommonFromProps2[0],
    _splitCommonFromProps3 = _splitCommonFromProps2[1],
    _splitCommonFromProps4 = _splitCommonFromProps3.alignItems,
    alignItems = _splitCommonFromProps4 === void 0 ? "center" : _splitCommonFromProps4,
    background = _splitCommonFromProps3.background,
    children = _splitCommonFromProps3.children,
    className = _splitCommonFromProps3.className,
    _splitCommonFromProps5 = _splitCommonFromProps3.direction,
    direction = _splitCommonFromProps5 === void 0 ? "row" : _splitCommonFromProps5,
    _splitCommonFromProps6 = _splitCommonFromProps3.shadowColor,
    shadowColor = _splitCommonFromProps6 === void 0 ? "pageBackground" : _splitCommonFromProps6,
    gap = _splitCommonFromProps3.gap,
    otherProps = _objectWithoutProperties(_splitCommonFromProps3, _excluded);
  var vertical = direction === "column";
  var theme = (0, _reactJss.useTheme)();
  var isLTR = theme.direction === _Theme.Direction.ltr;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    start = _useState2[0],
    setStart = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    end = _useState4[0],
    setEnd = _useState4[1];
  var barRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (!barRef.current) {
      return function () {};
    }
    var observer = new ResizeObserver(function (item) {
      var _barRef$current, _barRef$current2, _barRef$current3, _barRef$current4;
      var height = item[0].contentRect.height;
      var width = item[0].contentRect.width;
      if (direction === "row" && (barRef === null || barRef === void 0 || (_barRef$current = barRef.current) === null || _barRef$current === void 0 ? void 0 : _barRef$current.scrollWidth) - width > (barRef === null || barRef === void 0 || (_barRef$current2 = barRef.current) === null || _barRef$current2 === void 0 ? void 0 : _barRef$current2.scrollLeft)) {
        setEnd(true);
      } else if (direction === "column" && (barRef === null || barRef === void 0 || (_barRef$current3 = barRef.current) === null || _barRef$current3 === void 0 ? void 0 : _barRef$current3.scrollHeight) - height > (barRef === null || barRef === void 0 || (_barRef$current4 = barRef.current) === null || _barRef$current4 === void 0 ? void 0 : _barRef$current4.scrollTop)) {
        setEnd(true);
      } else {
        setEnd(false);
      }
    });
    observer.observe(barRef === null || barRef === void 0 ? void 0 : barRef.current);
    return function () {
      return observer.disconnect();
    };
  }, [barRef, direction]);
  var classes = (0, _Scroller.default)(_objectSpread({}, _Scroller.scrollerVars.useVars(_objectSpread({
    contentAlign: alignItems,
    background: background,
    scrollBarGap: gap,
    shadowColor: background !== null && background !== void 0 ? background : shadowColor
  }, common))));
  var showEnd = function showEnd() {
    setStart(false);
    setEnd(true);
  };
  var showStart = function showStart() {
    setStart(true);
    setEnd(false);
  };
  var showBoth = function showBoth() {
    setStart(true);
    setEnd(true);
  };
  var scrollHorizontal = function scrollHorizontal(target) {
    var scrollLeft = Math.abs(target.scrollLeft);
    if (scrollLeft < THRESHOLD) {
      return showEnd();
    }
    if (scrollLeft + target.clientWidth + THRESHOLD >= target.scrollWidth) {
      return showStart();
    }
    return showBoth();
  };
  var scrollVertical = function scrollVertical(target) {
    if (!target.scrollTop) {
      return showEnd();
    }
    if (target.scrollTop + target.clientHeight === target.scrollHeight) {
      return showStart();
    }
    return showBoth();
  };
  var onScrollClick = function onScrollClick(flip) {
    return barRef.current.scrollTo({
      left: barRef.current.scrollLeft + SCROLL_STEP * flip,
      behavior: "smooth"
    });
  };
  var handleScroll = function handleScroll(event) {
    var target = event.target;
    if (direction === "row") {
      scrollHorizontal(target);
    } else {
      scrollVertical(target);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    ref: ref,
    className: (0, _classnames.default)(classes.variablesRoot, classes.root, className)
  }, otherProps), /*#__PURE__*/_react.default.createElement("div", {
    ref: barRef,
    className: (0, _classnames.default)(classes.bar, _defineProperty({}, classes.vertical, vertical)),
    onScroll: handleScroll
  }, children), direction === "row" && start && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.icon, classes.iconStart)
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    name: "chevronLeft",
    onClick: function onClick() {
      return onScrollClick(isLTR ? -1 : 1);
    },
    disabled: !start
  })), direction === "row" && end && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.icon, classes.iconEnd)
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    name: "chevronRight",
    onClick: function onClick() {
      return onScrollClick(isLTR ? 1 : -1);
    },
    disabled: !end
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.shadow, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, classes.shadowVisible, start), classes.start, !vertical), classes.top, vertical), classes.startShadow, !isLTR), classes.endShadow, isLTR))
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.shadow, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, classes.shadowVisible, end), classes.end, !vertical), classes.bottom, vertical), classes.startShadow, isLTR), classes.endShadow, !isLTR))
  }));
});
Scroller.displayName = "Scroller";
var Storybook = exports.Storybook = Scroller;

/**
 * @see https://icfreactcomponents.integ.icfsys.com/?path=/docs/structure-scroller--docs
 */
var exportedComponent = (0, _defaultProps.default)(Scroller);
exportedComponent.displayName = "Scroller";
var _default = exports.default = exportedComponent;